import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import axios from "axios";

const uploadFile = (url, picture) => {
  return api.post(url, picture , {headers : { "Content-Type": "multipart/form-data"}});
};

const downloadFile = (url) => {
  return api.get(url , {responseType :"arraybuffer"} );
};

const downloadFileXML = (url) => {
  return axios.get("http://149.56.30.111:8090"+url , {responseType :"arraybuffer"} );
};

export default {
  uploadFile,
  downloadFile,downloadFileXML
};
